export const getNoAuthJsonHeader = () => {
    return { Accept: 'application/json', 'Content-Type': 'application/json' }
}
